<template>
  <div class="flex flex-col items-end ss xxx">
    TEAM
  </div>
</template>